export default __webpack_public_path__ + "static/media/dashboard_empty.3df95b71.png";